export class EventsRequest {
    constructor() {
        this.status = 'INITIALIZING';
    }
}
//# sourceMappingURL=eventsRequest.js.map